import { useState } from "react";
import { toast } from "sonner";
import { api, err, fileUrl } from "../../lib/api";
import { useSite } from "../../lib/site";

const FIELDS = [["site_name", "Website name"], ["announcement", "Announcement (home page)", "full"], ["upi_id", "UPI ID (shown on deposit)"], ["payee_name", "Payee name"],
  ["support_contact", "Support Telegram (e.g. @laxmiwin9090)"], ["bank_name", "Bank name"], ["bank_account_holder", "Bank account holder"],
  ["bank_account_number", "Bank account number"], ["bank_ifsc", "Bank IFSC"], ["min_deposit", "Min deposit ₹", "", "number"], ["max_deposit", "Max deposit ₹", "", "number"], ["min_withdraw", "Min withdrawal ₹", "", "number"]];

function Upload({ kind, label, url, onUploaded }) {
  const [busy, setBusy] = useState(false);
  const send = async e => {
    const file = e.target.files[0];
    if (!file) return;
    setBusy(true);
    const form = new FormData(); form.append("file", file);
    try { const r = await api.post(`/admin/settings/upload/${kind}`, form); onUploaded(r.data); toast.success(`${label} uploaded`); } catch (x) { toast.error(err(x)); }
    setBusy(false); e.target.value = "";
  };
  return (
    <div className="upload-box" data-testid={`upload-${kind}-box`}>
      {url ? <img src={url.startsWith("/api") ? fileUrl(url) : url} alt={label} data-testid={`${kind}-preview`} /> : <div className="ph">No {label}</div>}
      <div><b>{label}</b><p className="report-note">PNG, JPG or WEBP · max 5 MB</p>
        <label className="btn" style={{ display: "inline-block", cursor: "pointer" }}>{busy ? "Uploading…" : `Upload ${label}`}<input type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={send} data-testid={`upload-${kind}-input`} /></label></div>
    </div>
  );
}

export default function AdminSettings() {
  const { site, setSite } = useSite();
  const [f, setF] = useState(site);
  const save = async () => {
    const body = Object.fromEntries(FIELDS.map(([k, , , t]) => [k, t === "number" ? Number(f[k]) : f[k]]));
    try { const r = await api.patch("/admin/settings", body); setSite(r.data); toast.success("Settings saved"); } catch (e) { toast.error(err(e)); }
  };
  const uploaded = d => { setSite(d); setF(x => ({ ...x, qr_url: d.qr_url, logo_url: d.logo_url })); };
  return (
    <>
      <section className="admin-section"><h2>Payment QR & logo</h2>
        <div className="admin-form"><Upload kind="qr" label="Payment QR" url={site.qr_url} onUploaded={uploaded} /><Upload kind="logo" label="Logo" url={site.logo_url || "/assets/logo.png"} onUploaded={uploaded} /></div>
        {site.logo_url && <button className="btn ghost" onClick={async () => { const r = await api.delete("/admin/settings/upload/logo"); uploaded(r.data); toast.success("Default Laxmiwin logo restored"); }} data-testid="reset-logo-button">Use default logo</button>}</section>
      <section className="admin-section"><h2>Website settings</h2>
        <div className="admin-form">{FIELDS.map(([k, label, cls, type]) => <label key={k} className={cls}>{label}<input type={type || "text"} value={f[k] ?? ""} onChange={e => setF({ ...f, [k]: e.target.value })} data-testid={`setting-${k}-input`} /></label>)}
          <div className="full"><button className="btn green" onClick={save} data-testid="save-settings-button">Save settings</button></div></div></section>
    </>
  );
}
